import { adminAccessUserTypes } from "../constants/action-types"

const initialState = {
  appCode: "CGI",
  cuit: "",
  orgFinishDate: "",
  userFinishDate: "",
  selectedRoleCodes: [],
  applicationsRoutes: [],
  loadingAppsRoutes: false,
  hasSearchedOrganization: false,
  organization: null,
  orgAccess: null,
  applicationInstanceId: "",
  organizationUsers: [],

  selectedUser: null,
  userAccess: null,
  userAppAccessId: "",
  grantedRoleCodes: [],

  roles: [],
  modules: [],
  params: [],
  loadingRoles: false,
  loadingModules: false,
  loadingParams: false,

  validatingOrganization: false,
  loadingOrgContext: false,
  enablingOrganizationAccess: false,
  loadingUserContext: false,
  enablingUserAccess: false,
  submittingUserRoles: false,
  revokingUserRole: false,

  error: null,
  successMessage: null,
}

const clearUserSection = () => {
  return {
    selectedUser: null,
    userFinishDate: "",
    selectedRoleCodes: [],
    userAccess: null,
    userAppAccessId: "",
    grantedRoleCodes: [],
  }
}

const clearOrganizationSection = () => {
  return {
    hasSearchedOrganization: false,
    organization: null,
    orgAccess: null,
    applicationInstanceId: "",
    organizationUsers: [],
    orgFinishDate: "",
    ...clearUserSection(),
  }
}

export const adminAccessUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case adminAccessUserTypes.ADMIN_ACCESS_RESET:
      return {
        ...initialState,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_CLEAR_MESSAGES:
      return {
        ...state,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SET_CUIT:
      if (action.payload === state.cuit) {
        return {
          ...state,
          error: null,
          successMessage: null,
        }
      }

      return {
        ...state,
        cuit: action.payload,
        roles: state.roles,
        loadingRoles: state.loadingRoles,
        ...clearOrganizationSection(),
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SET_ORG_FINISH_DATE:
      return {
        ...state,
        orgFinishDate: action.payload,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SET_USER_FINISH_DATE:
      return {
        ...state,
        userFinishDate: action.payload,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SET_SELECTED_ROLES:
      return {
        ...state,
        selectedRoleCodes: action.payload,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SET_SELECTED_USER:
      return {
        ...state,
        selectedUser: action.payload,
        userFinishDate: "",
        selectedRoleCodes: [],
        userAccess: null,
        userAppAccessId: "",
        grantedRoleCodes: [],
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ROLES_REQUEST:
      return {
        ...state,
        loadingRoles: true,
        error: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ROLES_SUCCESS:
      return {
        ...state,
        loadingRoles: false,
        roles: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ROLES_FAILURE:
      return {
        ...state,
        loadingRoles: false,
        error: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_VALIDATE_ORG_REQUEST:
      return {
        ...state,
        validatingOrganization: true,
        hasSearchedOrganization: false,
        ...clearOrganizationSection(),
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_VALIDATE_ORG_SUCCESS:
      return {
        ...state,
        validatingOrganization: false,
        hasSearchedOrganization: true,
        organization: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_VALIDATE_ORG_FAILURE:
      return {
        ...state,
        ...clearOrganizationSection(),
        error: action.payload,
        hasSearchedOrganization: true,
        validatingOrganization: false,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ORG_CONTEXT_REQUEST:
      return {
        ...state,
        loadingOrgContext: true,
        error: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ORG_CONTEXT_SUCCESS:
      return {
        ...state,
        loadingOrgContext: false,
        orgAccess: action.payload?.orgAccess || null,
        applicationInstanceId: action.payload?.applicationInstanceId || "",
        organizationUsers: action.payload?.organizationUsers || [],
        orgFinishDate:
          Object.prototype.hasOwnProperty.call(action.payload || {}, "orgFinishDate")
            ? action.payload.orgFinishDate
            : state.orgFinishDate,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ORG_CONTEXT_FAILURE:
      return {
        ...state,
        loadingOrgContext: false,
        error: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_ORG_REQUEST:
      return {
        ...state,
        enablingOrganizationAccess: true,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_ORG_SUCCESS:
      return {
        ...state,
        enablingOrganizationAccess: false,
        successMessage: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_ORG_FAILURE:
      return {
        ...state,
        enablingOrganizationAccess: false,
        error: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_REQUEST:
      return {
        ...state,
        loadingUserContext: true,
        error: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_SUCCESS:
      return {
        ...state,
        loadingUserContext: false,
        userAccess: action.payload?.userAccess || null,
        userAppAccessId: action.payload?.userAppAccessId || "",
        grantedRoleCodes: action.payload?.grantedRoleCodes || [],
        userFinishDate:
          Object.prototype.hasOwnProperty.call(action.payload || {}, "userFinishDate")
            ? action.payload.userFinishDate
            : state.userFinishDate,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_USER_CONTEXT_FAILURE:
      return {
        ...state,
        loadingUserContext: false,
        error: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_USER_REQUEST:
      return {
        ...state,
        enablingUserAccess: true,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_USER_SUCCESS:
      return {
        ...state,
        enablingUserAccess: false,
        successMessage: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_USER_FAILURE:
      return {
        ...state,
        enablingUserAccess: false,
        error: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SUBMIT_ROLES_REQUEST:
      return {
        ...state,
        submittingUserRoles: true,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SUBMIT_ROLES_SUCCESS:
      return {
        ...state,
        submittingUserRoles: false,
        selectedRoleCodes: [],
        successMessage: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_SUBMIT_ROLES_FAILURE:
      return {
        ...state,
        submittingUserRoles: false,
        error: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_REVOKE_ROLE_REQUEST:
      return {
        ...state,
        revokingUserRole: true,
        error: null,
        successMessage: null,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_REVOKE_ROLE_SUCCESS:
      return {
        ...state,
        revokingUserRole: false,
        successMessage: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_REVOKE_ROLE_FAILURE:
      return {
        ...state,
        revokingUserRole: false,
        error: action.payload,
      }


    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_MODULE_REQUEST:
      return {
        ...state,
        loadingModules: true,
        error: null,
        successMessage: null,
        modules: []
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_MODULE_SUCCESS:
      return {
        ...state,
        loadingModules: false,
        modules: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_MODULE_FAILURE:
      return {
        ...state,
        loadingModules: false,
        error: action.payload,
        modules: []
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_PARAMS_REQUEST:
      return {
        ...state,
        loadingParams: true,
        error: null,
        successMessage: null,
        params: []
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_PARAMS_SUCCESS:
      return {
        ...state,
        loadingParams: false,
        params: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_ENABLE_PARAMS_FAILURE:
      return {
        ...state,
        loadingParams: false,
        error: action.payload,
        params: []
      }

    case adminAccessUserTypes.ADMIN_ACCESS_APP_CODE:
      return {
        ...state,
        appCode: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_APPLICATIONS_REQUEST:
      return {
        ...state,
        loadingAppsRoutes: true,
        error: null,
        successMessage: null,
        applicationsRoutes: []
      }

    case adminAccessUserTypes.ADMIN_ACCESS_APPLICATIONS_SUCCESS:
      return {
        ...state,
        loadingAppsRoutes: false,
        applicationsRoutes: action.payload,
      }

    case adminAccessUserTypes.ADMIN_ACCESS_APPLICATIONS_FAILURE:
      return {
        ...state,
        loadingAppsRoutes: false,
        error: action.payload,
        applicationsRoutes: []
      }
    default:
      return state
  }
}

export default adminAccessUserReducer
